import isEmpty from "../../is-Empty";
import Validator from "validator";

export const OffersValidation = (data) => {
  let errors = {};

  data.name = !isEmpty(data.name) ? data.name : "";
  data.description = !isEmpty(data.description) ? data.description : "";
  data.startDate = !isEmpty(data.startDate) ? data.startDate : "";
  data.endDate = !isEmpty(data.endDate) ? data.endDate : "";
  data.couponCode = !isEmpty(data.couponCode) ? data.couponCode : "";
  // data.addOffer = !isEmpty(data.addOffer) ? data.addOffer : "";
  // data.address = !isEmpty(data.address) ? data.address : "";
  data.termsConditions = !isEmpty(data.termsConditions)
    ? data.termsConditions
    : "";

  if (Validator.isEmpty(data.termsConditions)) {
    errors.termsConditions = "Terms and Conditions is Required";
  }
  // if (Validator.isEmpty(data.address)) {
  //   errors.address = "Address is Required";
  // }
  // if (Validator.isEmpty(data.addOffer)) {
  //   errors.addOffer = "Image is Required";
  // }
  if (Validator.isEmpty(data.couponCode)) {
    errors.couponCode = "coupon code is Required";
  }
  if (Validator.isEmpty(data.endDate)) {
    errors.endDate = "end date is Required";
  }
  if (Validator.isEmpty(data.startDate)) {
    errors.startDate = "start date is Required";
  }
  if (Validator.isEmpty(data.description)) {
    errors.description = "description is required";
  }
  if (Validator.isEmpty(data.name)) {
    errors.name = "name is required";
  }

  return {
    errors,
    isValid: isEmpty(errors),
  };
};
